'use client'
import { useMemo, type FC } from 'react'
import { SectionContents } from './SectionContents'
import type { TypeCmsContentPage, TypeCmsProjectInProduct } from '@/schema'
import { SectionNavLinks } from './SectionNavLinks'
// import { useParams } from 'next/navigation'
import { Link } from './commons'
import { SectionExploreProjects } from './SectionExploreProjects'
import { SectionFavourites } from './SectionFavourites'
import { mq, vw } from '@/styles'
import styled from 'styled-components'
import { SectionListDownload } from './SectionListDownload'
import { usePathname } from 'next/navigation'

type Props = {
  data: {
    contents: TypeCmsContentPage['contents']
    products: TypeCmsContentPage['products']
    submenu: TypeCmsContentPage['menu']
    projects: TypeCmsProjectInProduct[]
    downloads: TypeCmsContentPage['downloads']
  }
}

const getLinks = (data: TypeCmsContentPage['menu'], pathname) => data.map((item, idx) => {
  if (!item?.pathname) return null
  const isActive = pathname.includes(item.pathname)

  return (
    <div key={idx}>
      <Link href={`${item.pathname}`} className={isActive ? 'active':''}>{item.name}</Link>
    </div>
  )
})

export const MainContents:FC<Props> = ({ data }) => {
  // const { lang }: { lang: TypeLang } = useParams()
  const { contents, submenu, projects, products, downloads } = data
  const pathname = usePathname()
  const Slides = useMemo(() => submenu && getLinks(submenu, pathname), [pathname, submenu])


  return (
    <MainContent>
      {submenu?.length > 0 && <SectionNavLinks title='menu' slides={Slides} />}
      {contents && <SectionContents data={contents} />}
      {projects?.length > 0 && <SectionExploreProjects data={projects} />}
      {products?.length > 0 && <SectionFavourites data={products} />}
      {downloads?.length > 0 && <SectionListDownload downloads={downloads}/>}
    </MainContent>
  )
}


export const MainContent = styled.main`
  width: 100vw;
  width: 100dvw;

  section {
    /* &:not([class*='SectionContents__']) {
      margin-bottom: ${vw(60, 'mobile')};
    } */

    &:first-of-type:nth-last-of-type(n+3)   {
      margin-top: ${vw(60, 'mobile')};

      ${mq.greaterThan('tablet')} {
        margin-top: ${vw(60, 'desktop')};
      }

      ${mq.greaterThan('desktop')} {
        margin-top: 60px;
      }

      /* &[aria-labelledby='s-links-title'] {
        margin-top: 0;
      } */
    }



    ${mq.greaterThan('tablet')} {
      /* &:not([class*='SectionContents__']) {
        margin-bottom: ${vw(60, 'desktop')};
      } */

      &:first-of-type {
        margin-top: ${vw(60, 'desktop')};
      }

    }
  }


`
